export enum ModalSectionMode {
	fieldSet = 0,
	navPills = 1,
}

/**
 * Controls how the section content is scrolled when the user switches between
 * side-pill sections (navPills mode). Has no effect in fieldSet mode.
 */
export enum ModalSectionPillScrollMode {
	/** Leave the scroll position untouched when switching sections. */
	disabled = 0,
	/** Always scroll the content back to the top when a section is selected. */
	scrollToTop = 1,
	/**
	 * Remember each section's scroll position and restore it when that section is
	 * selected again; scroll to the top when nothing has been remembered yet.
	 */
	rememberPosition = 2,
}
